import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

import { OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE } from 'Constants'
import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex
} from 'mailup-web-components'
import { editCallback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import { modalActivateSimulateSimulateCallback } from 'Pages/Workflow/recoil/callbacks/modalActivateSimulate'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import { pageState } from 'Pages/Workflow/recoil/state/page'

const Footer = () => {
  const intl = useIntl()
  const history = useHistory()

  const edit = useRecoilCallback(editCallback, [])
  const setPageState = useSetRecoilState(pageState)
  const { edit: editPage, saveAndExit } = useRecoilValue(pageState)
  const { Type } = useRecoilValue(workflowDetails)

  const handleBack = () => {
    edit(4)
  }

  const handleSimulate = useRecoilCallback(
    modalActivateSimulateSimulateCallback,
    []
  )

  useEffect(() => {
    saveAndExit &&
      history.push(
        `/automation/workflows/list?saved=1&edit=${editPage ? 1 : 0}`
      )
  }, [saveAndExit])

  const handleSave = () => {
    setPageState((prev) => ({ ...prev, isDirty: false, saveAndExit: true }))
  }

  return (
    <Flex alignItems='center' justifyContent='space-between'>
      <Button
        kind={BUTTON_VARIANT_SECONDARY}
        data-mu-test='back'
        onClick={handleBack}
      >
        {intl.formatMessage({ id: 'Load.AutomationWorkflow.PrevStepButton' })}
      </Button>
      <Flex alignItems='center' gap='8px'>
        {Type === OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE && (
          <Button
            kind={BUTTON_VARIANT_SECONDARY}
            data-mu-test='simulate'
            onClick={handleSimulate}
          >
            {intl.formatMessage({
              id: 'Load.ModalSimulates.Title'
            })}
          </Button>
        )}

        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test='save'
          onClick={handleSave}
        >
          {intl.formatMessage({ id: 'Load.AutomationWorkflow.SaveNotActive' })}
        </Button>
      </Flex>
    </Flex>
  )
}

export default Footer
